import { Select } from "antd";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { search_city_user_action } from "../../redux/_actions";

export const CitySearchDropdown = ({
  searchStyle,
  placeholder,
  onSearchSelect,
  stateKey,
  defaultCityValue,
}) => {
  const [data, setData] = useState([]);
  const [value, setValue] = useState();
  const [loading, setLoading] = useState();

  const { citySearchData } = useSelector(
    (state) => state.search_city_user_reducer
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (citySearchData?.data) {
      setData(citySearchData?.data);
    }
  }, [citySearchData]);

  useEffect(() => {
    setValue(defaultCityValue);
  }, [defaultCityValue]);

  useEffect(() => {
    handleSearch();
  }, [stateKey]);

  // remove input's autocomplete
  useEffect(() => {
    const el = document.getElementsByClassName(
      "ant-select-selection-search-input"
    );
    for (let i = 0; i < el.length; i++) {
      el[i].setAttribute("autocomplete", "registration-select");
    }
  }, []);

  const handleSearch = async () => {
    setLoading(true);
    if (stateKey)
      await dispatch(
        search_city_user_action({
          index: "city",
          search_key: "",
          state: stateKey,
          search: "",
          page_size: 260,
        })
      );
    setLoading(false);
  };

  const handleChange = (newValue) => {
    let index = data && data.findIndex((i) => i.id === newValue);
    if (index >= 0) {
      let state = data[index];
      onSearchSelect(state);
      setValue(state?.name);
    }
  };
  const onSearch = (newValue) => {
    return null;
  };
  return (
    <Select
      optionFilterProp="children"
      filterOption={(input, option) =>
        (option?.label ?? "").toLowerCase().startsWith(input.toLowerCase())
      }
      filterSort={(optionA, optionB) =>
        (optionA?.label ?? "")
          .toLowerCase()
          .localeCompare((optionB?.label ?? "").toLowerCase())
      }
      showSearch
      value={value}
      placeholder={placeholder}
      style={searchStyle}
      onSearch={onSearch}
      onChange={handleChange}
      notFoundContent={
        loading ? (
          <Spinner animation="grow" variant="primary" size={"sm"} />
        ) : (
          <p className="text-primary">No City Found</p>
        )
      }
      options={
        Array.isArray(data) &&
        data.map((d) => ({
          value: d?.id,
          label: d?.name,
        }))
      }
      getPopupContainer={(trigger) => trigger.parentNode}
    />
  );
};
